{
  "ariaLabel": "FAA-Zuordnungs-Tabs",
  "tabs": {
    "aircraftMapping": "Flugzeugzuordnung",
    "tailManualAdd": "Kennzeichen hinzufügen",
    "blacklist": "Sperrliste",
    "tailRequests": "Kennzeichen-Anfragen",
    "pendingApprovals": "Ausstehende Genehmigungen"
  },
  "tailMappingTab": {
    "title": "Manuell FAA-Kennzeichen hinzufügen",
    "description": "Neues Kennzeichen zur FAA-Datenbank hinzufügen und einem Flugzeugtyp zuordnen. Das Kennzeichen ist sofort für Massenimporte und Planung verfügbar.",
    "form": {
      "labels": {
        "tailNumber": "Kennzeichen",
        "manufacturer": "Hersteller",
        "model": "Modell",
        "aircraft": "Flugzeugtyp"
      },
      "placeholders": {
        "tailNumber": "N12345",
        "manufacturer": "CESSNA",
        "model": "172S"
      },
      "buttons": {
        "add": "Tail-Nummer hinzufügen",
        "adding": "Hinzufügen..."
      },
      "validation": {
        "tailNumberRequired": "Kennzeichen ist erforderlich",
        "tailNumberFormat": "Kennzeichen darf nur Buchstaben, Zahlen und Bindestriche enthalten",
        "tailNumberLength": "Kennzeichen muss zwischen 2 und 10 Zeichen lang sein",
        "manufacturerRequired": "Hersteller ist erforderlich",
        "manufacturerLength": "Hersteller muss zwischen 2 und 100 Zeichen lang sein",
        "modelRequired": "Modell ist erforderlich",
        "modelLength": "Modell muss zwischen 1 und 100 Zeichen lang sein",
        "aircraftRequired": "Bitte wähle einen Flugzeugtyp aus"
      }
    },
    "recentlyAdded": {
      "title": "Kürzlich hinzugefügte Kennzeichen",
      "emptyState": "Keine kürzlich hinzugefügten Kennzeichen",
      "columns": {
        "tailNumber": "Kennzeichen",
        "manufacturer": "Hersteller",
        "model": "Modell",
        "source": "Quelle",
        "added": "Neu",
        "actions": "Aktionen"
      },
      "sources": {
        "faaImport": "FAA-Import",
        "justNow": "Gerade eben"
      }
    },
    "deleteDialog": {
      "title": "Tail-Nummer löschen",
      "confirmationText": "Möchtest du das Kennzeichen <strong>{{tailNumber}}</strong> wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
      "instructionsText": "Um das Löschen zu bestätigen, gib bitte <strong>delete</strong> in das Feld unten ein:",
      "placeholder": "Gib delete ein, um zu bestätigen",
      "validationError": "Bitte gib delete genau so ein",
      "buttons": {
        "cancel": "Abbrechen",
        "delete": "Löschen",
        "deleting": "Löschen..."
      }
    },
    "tooltips": {
      "delete": "Tail-Nummer {{tailNumber}} löschen"
    },
    "messages": {
      "alreadyExists": "Kennzeichen {{tailNumber}} ist bereits in der Datenbank vorhanden",
      "permissionDenied": "Du hast keine Berechtigung, Tail Numbers hinzuzufügen",
      "addFailed": "Tail-Nummer konnte nicht hinzugefügt werden: {{message}}",
      "addSuccess": "Tail-Nummer {{tailNumber}} erfolgreich hinzugefügt",
      "addSuccessNoMapping": "Kennzeichen {{tailNumber}} hinzugefügt, aber die Zuordnung erfordert möglicherweise manuelle Überprüfung",
      "deleteFailed": "Löschen der Kennzeichen fehlgeschlagen: {{message}}",
      "deleteSuccess": "Kennzeichen {{tailNumber}} erfolgreich gelöscht",
      "error": "Fehler: {{message}}",
      "unexpectedError": "Ein unerwarteter Fehler ist aufgetreten",
      "unexpectedDeleteError": "Beim Löschen ist ein unerwarteter Fehler aufgetreten"
    }
  },
  "suggestedAircraftCell": {
    "confidence": {
      "high": "Hoch",
      "medium": "Mittel",
      "label": "Vertrauen"
    },
    "score": "Punkte:",
    "tooltip": {
      "matchDetails": "Trefferdetails",
      "faaInput": "FAA-Eingabe (was du zuordnest):",
      "suggestedAircraft": "Vorgeschlagene Flugzeuge:",
      "modelComparison": "Modellvergleich:",
      "faa": "FAA:",
      "airplx": "AirPlx:",
      "legend": {
        "match": "✓ Treffer",
        "case": "~ Fall",
        "different": "✗ anders"
      },
      "whyMatch": "Warum dieser Treffer?",
      "matchQuality": "Übereinstimmungsqualität:",
      "verifiedMatch": "✓ Exakt übereinstimmend bestätigt",
      "manufacturer": "Hersteller:",
      "model": "Modell:",
      "noDirectMatch": "kein direkter Treffer",
      "scoreLabel": "Punkte",
      "matchLabels": {
        "highMatch": "passt ✓",
        "mediumMatch": "~passt",
        "noMatch": "kein Treffer ✗"
      },
      "otherMatches": "Weitere mögliche Treffer:",
      "clickAlternative": "Klicke auf eine Alternative, um sie auszuwählen",
      "instructions": "Klicke auf das Häkchen zum Bestätigen oder wähle manuell aus, falls falsch"
    },
    "matchReasons": {
      "csvVerified": "Dieser FAA-String {{matchedString}} wurde bereits diesem Flugzeug zugeordnet",
      "csvVerifiedFallback": "In verifizierten Datenbankzuordnungen gefunden",
      "historical": "Ähnlich wie zuvor zugeordnet: {{matchedString}}",
      "historicalFallback": "Basierend auf historischen Zuordnungsmustern",
      "combined": "Treffer gefunden durch Datenbankhistorie und unscharfe Textsuche",
      "traditional": "Treffer durch unscharfe Textsuche von Hersteller und Modell gefunden",
      "unknown": "Unbekannte Abgleichmethode"
    }
  }
}
